import { render, staticRenderFns } from "./LegacyNewsArticle.vue?vue&type=template&id=339ff9d7&scoped=true"
import script from "./LegacyNewsArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegacyNewsArticle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LegacyNewsArticle.vue?vue&type=style&index=0&id=339ff9d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339ff9d7",
  null
  
)

export default component.exports